import React, { useCallback, useEffect, useState } from 'react';
import { Box, LeftRow, Row, Subtitle, Tag, Title } from '../styles';
import Modal from '../../modals/modal';
import SearchRepositoryModel from '../../modals/searchRepositoryModal';
import { updateProjectData } from '../../../services/projectServices';
import { captureException } from '../../../services/logService';
import { GithubRepositoryList } from '../../../interfaces/SettingsInterface';
import { getRepositoryList } from '../../../services/githubServices';
import { rootStore } from '../../../mobx/rootStore';

export default function GithubRepository() {
  //State variables
  const [loading, setLoading] = useState(true);
  const [isRepositoryModelOpen, setIsRepositoryModelOpen] = useState(false);
  const [githubRepositoryList, setGithubRepositoryList] = useState<GithubRepositoryList[]>([]);
  const [selectedRepository, setSelectedRepository] = useState<GithubRepositoryList>();

  //Mobx store variables
  const { workspaceStore, projectStore } = rootStore;
  const { currentWorkspace: workspace } = workspaceStore;
  const { currentProject } = projectStore;

  // Load selected repo name
  const loadData = useCallback(async () => {
    try {
      setLoading(true);
      if (workspace?.id) {
        const repoList: GithubRepositoryList[] = await getRepositoryList();
        const selectedRepo = repoList?.find(
          (repo: GithubRepositoryList) => repo?.id === currentProject?.githubRepository
        );
        setSelectedRepository(selectedRepo);
        setGithubRepositoryList(repoList);
      }
    } catch (err) {
      console.log('error: ', err);
    } finally {
      if (workspace?.id) setLoading(false);
    }
  }, [currentProject?.githubRepository, workspace?.id]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  // function to set repositories
  const handleSelectRepository = useCallback(
    async (repo: GithubRepositoryList) => {
      try {
        setLoading(true);
        const payload = { GithubRepository: repo?.id };
        const result = await updateProjectData(currentProject?.id, payload);
        if (result) {
          currentProject?.setGithubRepository(repo?.id);
          setSelectedRepository(repo);
          setIsRepositoryModelOpen(false);
        }
      } catch (e) {
        captureException(e);
      } finally {
        setLoading(false);
      }
    },
    [currentProject]
  );

  // select repo model open
  const handleSelectProject = useCallback(() => {
    setIsRepositoryModelOpen(true);
  }, []);

  // select repo model close
  const handleCloseModel = useCallback(() => {
    setIsRepositoryModelOpen(false);
  }, []);
  return (
    <>
      <Box>
        <Row>
          <LeftRow>
            <Title>Github Repository</Title>
            {/* show project name */}
            <Subtitle>{selectedRepository?.fullName || ''}</Subtitle>
          </LeftRow>

          {/* repository is selected */}
          <Tag role='button' onClick={handleSelectProject}>
            Change
          </Tag>
        </Row>
      </Box>
      <Modal open={isRepositoryModelOpen} onClose={handleCloseModel} maxWidth={'460px'}>
        <SearchRepositoryModel
          githubRepositoryList={githubRepositoryList}
          onClose={handleCloseModel}
          handleSelect={handleSelectRepository}
          loading={loading}
        />
      </Modal>
    </>
  );
}
